import React from 'react';
import { withRouter } from 'react-router-dom';

import UsersTableList from 'components/UsersTableList';
import Layout from 'components/Layout';
import i18n from 'i18n-js';

const UsersList = ({ history }) => {
  return (
    <Layout title={i18n.t('customers.title')}>
      <UsersTableList
        type="customer"
        path="customers"
        history={history}
        isCustomer={true}
        title={i18n.t('customers.title')}
      />
    </Layout>
  );
};

export default withRouter(UsersList);
